import { gql } from "@apollo/client";

export const CHANGE_PASSWORD = gql`
    mutation ChangePassword($password: String!, $newPassword: String!) {
        changePassword(password: $password, newPassword: $newPassword ) {
            status
            id,
        }
    }
`;

export const REQUEST_OTP = gql`
mutation RequestOtp($verificationType:String!){
    requestOtp(verificationType:$verificationType){
        status,
    }
}
`;

export const SUBMIT_OTP = gql`
mutation SubmitOTPVerifyPhone($verificationType:String!,$verificationCode:String!,$phoneNumber:String!){
    submitOTPVerifyPhone(verificationType:$verificationType,verificationCode:$verificationCode,phoneNumber:$phoneNumber){
        status,
    }
}
`;

export const SUBMIT_OTP_CREATE_PHONE = gql`
mutation SubmitOTPCreatePhone($verificationType:String!,$verificationCode:String!,$phoneNumber:String!,$newPhoneNumber:String!){
    submitOTPCreatePhone(verificationType:$verificationType,verificationCode:$verificationCode,phoneNumber:$phoneNumber,newPhoneNumber:$newPhoneNumber){
        status,
    }
}
`;

export const PROFILE_COMM = gql`
query profileComm{
    profileComm{
        id
        totalPendingCommission
        totalPendingWithdrawal
        balance
    }
}
`